/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingMelcoDigitizingModelsOrderListItem
 */
export interface DigitizingMelcoDigitizingModelsOrderListItem {
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderListItem
     */
    order_reference_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderListItem
     */
    design_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderListItem
     */
    order_status?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DigitizingMelcoDigitizingModelsOrderListItem
     */
    created_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DigitizingMelcoDigitizingModelsOrderListItem
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof DigitizingMelcoDigitizingModelsOrderListItem
     */
    is_payment_done?: boolean;
}

export function DigitizingMelcoDigitizingModelsOrderListItemFromJSON(json: any): DigitizingMelcoDigitizingModelsOrderListItem {
    return DigitizingMelcoDigitizingModelsOrderListItemFromJSONTyped(json, false);
}

export function DigitizingMelcoDigitizingModelsOrderListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingMelcoDigitizingModelsOrderListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'order_reference_number': !exists(json, 'order_reference_number') ? undefined : json['order_reference_number'],
        'design_name': !exists(json, 'design_name') ? undefined : json['design_name'],
        'order_status': !exists(json, 'order_status') ? undefined : json['order_status'],
        'created_date': !exists(json, 'created_date') ? undefined : (json['created_date'] === null ? null : new Date(json['created_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'is_payment_done': !exists(json, 'is_payment_done') ? undefined : json['is_payment_done'],
    };
}

export function DigitizingMelcoDigitizingModelsOrderListItemToJSON(value?: DigitizingMelcoDigitizingModelsOrderListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'order_reference_number': value.order_reference_number,
        'design_name': value.design_name,
        'order_status': value.order_status,
        'created_date': value.created_date === undefined ? undefined : (value.created_date === null ? null : value.created_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'is_payment_done': value.is_payment_done,
    };
}


